import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { Notification } from '../data-models/notification';
import { PlatformUser } from '../data-models/platform-user';
import { NotificationMessage } from '../data-models/notification-message';
import { LanguageService } from './language.service';
import { TranslatePipe } from 'src/app/shared/pipes/translate.pipe';
import { ModuleName } from 'src/app/shared/enums/ModuleName';
import { Database, onValue, ref, remove, update } from '@angular/fire/database';
import { from, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(public db: Database, private logService: LogService,
    private languageService: LanguageService, private translationPipe: TranslatePipe) { }
  ModuleNames = ModuleName

  updateUserNotificationList(platformUserKey: string, notification: Notification) {
    let prefix = '';
    if (notification.notiificationType === 'Q-STARTED') {
      prefix = '-QST';
    } else if (notification.notiificationType === 'Q-SUBMITTED') {
      prefix = '-QSB';
    }

    const refKey = notification.leaverKey + prefix;
    notification.key = refKey;

    const notificationRef = ref(this.db, `/NotificationList/${notification.tenantKey}/${platformUserKey}/${refKey}`);

    // `update` returns a Promise, so wrap it in an Observable
    return update(notificationRef, notification);
  }


  fetchUserNotifications(user: PlatformUser): Observable<Notification[]> {
    const notificationsRef = ref(this.db, `/NotificationList/${user.tenantKey}/${user.key}`);

    return new Observable<Notification[]>((observer) => {
      // Listen for realtime updates
      onValue(notificationsRef, (snapshot) => {
        const notifications: Notification[] = [];
        snapshot.forEach((childSnapshot) => {
          notifications.push({ key: childSnapshot.key!, ...childSnapshot.val() });
        });
        observer.next(notifications);
      }, (error) => observer.error(error));
    });
  }

  removeNotification(notificationKey: string, user: PlatformUser) {
    const notificationRef = ref(this.db, `/NotificationList/${user.tenantKey}/${user.key}/${notificationKey}`);
    return remove(notificationRef);
  }

  evaluateNotification(notification: Notification, language: string) {

    let message = new NotificationMessage;
    message.key = notification.key;
    message.type = notification.notiificationType;
    message.title = this.translationPipe.transform('txt_' + notification.notiificationType, language, this.ModuleNames.Common);

    if (message.type == 'Q-STARTED') {
      let leaverName = notification.name;
      let questionnaireName = this.languageService.extractNameLanguage(notification.questionnaireName, language);
      let messageTemplate: string = this.translationPipe.transform('txt_notification_questionnaire_started', language, this.ModuleNames.Common);
      messageTemplate = JSON.parse(JSON.stringify(messageTemplate));
      messageTemplate = messageTemplate.replace("#LEAVERNAME#", leaverName);
      messageTemplate = messageTemplate.replace("#QUESTIONNAIRE#", questionnaireName);
      message.message = messageTemplate;
    }
    if (message.type == 'Q-SUBMITTED') {
      let leaverName = notification.name;
      let questionnaireName = this.languageService.extractNameLanguage(notification.questionnaireName, language);
      let messageTemplate: string = this.translationPipe.transform('txt_notification_questionnaire_completed', language, this.ModuleNames.Common);
      messageTemplate = JSON.parse(JSON.stringify(messageTemplate));
      messageTemplate = messageTemplate.replace("#LEAVERNAME#", leaverName);
      messageTemplate = messageTemplate.replace("#QUESTIONNAIRE#", questionnaireName);
      message.message = messageTemplate;
    }

    if (message.type == 'Q-EXPIRING') {
      let leaverName = notification.name;
      let questionnaireName = this.languageService.extractNameLanguage(notification.questionnaireName, language);
      let messageTemplate: string = this.translationPipe.transform('txt_notification_questionnaire_expiring', language, this.ModuleNames.Common);
      messageTemplate = JSON.parse(JSON.stringify(messageTemplate));
      messageTemplate = messageTemplate.replace("#LEAVERNAME#", leaverName);
      messageTemplate = messageTemplate.replace("#QUESTIONNAIRE#", questionnaireName);
      message.message = messageTemplate;
    }

    if (message.type == 'Q-EXPIRED') {
      let leaverName = notification.name;
      let questionnaireName = this.languageService.extractNameLanguage(notification.questionnaireName, language);
      let messageTemplate: string = this.translationPipe.transform('txt_notification_questionnaire_expired', language, this.ModuleNames.Common);
      messageTemplate = JSON.parse(JSON.stringify(messageTemplate));
      messageTemplate = messageTemplate.replace("#LEAVERNAME#", leaverName);
      messageTemplate = messageTemplate.replace("#QUESTIONNAIRE#", questionnaireName);
      message.message = messageTemplate;
    }

    return message;
  }


}
